import loadable from '@loadable/component';
import { WithLazyHydration } from '../../WithLazyHydration';

const PromoCarouselLoadable = loadable(() => import('./PromoCarousel'), {
  resolveComponent: components => components.PromoCarousel
});

export const PromoCarousel = WithLazyHydration(PromoCarouselLoadable, {
  name: 'PromoCarouselLoadable'
});
